export default {
    methods: {
        stringFormatter(value) {
            return value.replace(/\s/g, '');
        },
        isEmpty(data) {
            return data === undefined || data === null || data === '';
        },
        downloadString(text, fileType, fileName) {
            const blob = new Blob([text], {type: fileType});

            const a = document.createElement('a');
            a.download = fileName;
            a.href = URL.createObjectURL(blob);
            a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setTimeout(function () {
                URL.revokeObjectURL(a.href);
            }, 1500);
        }
    }
}